import React  from 'react';
import './Display.css'





export default function Display(props){
    
        
     return (
        <div id="time-left" className={props.isStyleAlert ? "display-warning" : "display"}>
           {`${props.chrono[0]}:${props.chrono[1].toString().length < 2 ? props.chrono[1].toString().padStart(2,'0') : props.chrono[1] }`}
           
        </div>
    )
    
}